import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { FaTimes } from "react-icons/fa";

export default function QuestionFamilyDialog({ title, subtitle, onClose, children }) {
  const dialog = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialog.current?.querySelector("button")?.focus();
    const keydown = (event) => {
      if (event.isComposing || event.defaultPrevented) return;
      const nested = event.target?.closest?.('[role="dialog"]');
      if (nested && nested !== dialog.current) return;
      if (event.key === "Escape") {
        event.preventDefault();
        close.current();
      }
      if (event.key !== "Tab") return;
      const elements = [...dialog.current.querySelectorAll("button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), a[href], [tabindex='0']")].filter((element) => !element.closest("[hidden]"));
      const first = elements[0]; const last = elements[elements.length - 1];
      if (event.shiftKey && (document.activeElement === first || !dialog.current.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.current.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    };
    document.addEventListener("keydown", keydown);
    return () => {
      document.removeEventListener("keydown", keydown);
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);
  return createPortal(<Overlay onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <Dialog ref={dialog} role="dialog" aria-modal="true" aria-label={title}>
      <Header><div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div><Close type="button" aria-label="關閉題族視窗" onClick={onClose}><FaTimes /></Close></Header>
      <Body>{children}</Body>
    </Dialog>
  </Overlay>, document.body);
}
const Overlay = styled.div`position: fixed; inset: 0; z-index: 1400; padding: 24px; background: var(--app-modal-overlay, rgba(64, 64, 64, 0.72)); display: flex; align-items: center; justify-content: center; @media(max-width: 600px) { padding: 8px; }`;
const Dialog = styled.section`width: min(100%, 1040px); max-height: calc(100dvh - 48px); display: flex; flex-direction: column; border: 1px solid var(--app-border, #ddd); border-radius: 16px; box-shadow: 0 24px 80px rgba(0, 0, 0, .25); background: var(--app-surface, #fff); color: var(--app-text, #202124); overflow: hidden; @media(max-width:600px) { max-height: calc(100dvh - 16px); }`;
const Header = styled.header`padding: 20px 24px; border-bottom: 1px solid var(--app-border, #ddd); display: flex; gap: 16px; justify-content: space-between; align-items: start; h2 { margin: 0; font-size: 20px; } p { margin: 6px 0 0; font-size: 13px; color: var(--app-muted-text, #73777f); }`;
const Close = styled.button`display: inline-flex; padding: 10px; border: 1px solid var(--app-border, #ddd); background: var(--app-surface, #fff); color: inherit; border-radius: 8px; cursor: pointer;`;
const Body = styled.div`padding: 20px 24px; overflow: auto; min-height: 0; @media(max-width:600px) { padding: 16px; }`;
